import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
    contact: {
        address: "Avenue d'Auderghem 352, 1040 Etterbeek",
        phone: "0484 42 45 08",
        email: "contact@meuble-etterbeek.be",
        hours: "Lun – Ven · 9h00 – 18h00",
    },
    languages: { fr: true, nl: true, en: true },
    socials: {
        instagram: "https://instagram.com/",
        facebook: "https://www.facebook.com/people/Bed-Sofa/61579081103675/",
        linkedin: "",
    },
};

let cache = null;
const subscribers = new Set();

async function fetchOnce() {
    if (cache) return cache;
    try {
        const { data } = await axios.get(`${API}/settings`);
        cache = {
            contact: { ...DEFAULTS.contact, ...(data.contact || {}) },
            languages: { ...DEFAULTS.languages, ...(data.languages || {}) },
            socials: { ...DEFAULTS.socials, ...(data.socials || {}) },
        };
    } catch {
        cache = DEFAULTS;
    }
    subscribers.forEach((cb) => cb(cache));
    return cache;
}

export function invalidateSettings() {
    cache = null;
    fetchOnce();
}

export default function useSettings() {
    const [settings, setSettings] = useState(cache || DEFAULTS);
    useEffect(() => {
        let alive = true;
        const cb = (s) => {
            if (alive) setSettings(s);
        };
        subscribers.add(cb);
        fetchOnce().then((s) => alive && setSettings(s));
        return () => {
            alive = false;
            subscribers.delete(cb);
        };
    }, []);
    return settings;
}
